'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _templateObject = _taggedTemplateLiteral(['\n  from {\n      transform: translate3d(0, -110%, 0);\n      visibility: visible;\n      opacity: 0;\n  }\n  to {\n      opacity: 1;\n  }\n'], ['\n  from {\n      transform: translate3d(0, -110%, 0);\n      visibility: visible;\n      opacity: 0;\n  }\n  to {\n      opacity: 1;\n  }\n']),
  _templateObject2 = _taggedTemplateLiteral(['\n  from {\n      z-index: -1;\n      opacity: 1;\n  }\n  to {\n      visibility: hidden;\n      opacity: 0;\n      z-index: -1;\n      transform: translate3d(0, -100%, 0);\n  }\n'], ['\n  from {\n      z-index: -1;\n      opacity: 1;\n  }\n  to {\n      visibility: hidden;\n      opacity: 0;\n      z-index: -1;\n      transform: translate3d(0, -100%, 0);\n  }\n']),
  _templateObject3 = _taggedTemplateLiteral(['\n  width: 360px !important;\n  padding: unset !important;\n  .slide-enter {\n    animation-name: ', ';\n  }\n  .slide-exit {\n    animation-name: ', ';\n  }\n'], ['\n  width: 360px !important;\n  padding: unset !important;\n  .slide-enter {\n    animation-name: ', ';\n  }\n  .slide-exit {\n    animation-name: ', ';\n  }\n']);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _ToastContainerBase = require('./ToastContainerBase');
var _ToastContainerBase2 = _interopRequireDefault(_ToastContainerBase);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var slideInDown = (0, _styledComponents.keyframes)(_templateObject);
var slideOutUp = (0, _styledComponents.keyframes)(_templateObject2);
var ToastContainer = (0, _styledComponents2['default'])(_ToastContainerBase2['default'])(_templateObject3, slideInDown, slideOutUp);
exports['default'] = ToastContainer;